const ICONS = {
  glass: '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M16 27V16M8 27h16M10 16c0-6 3-10 6-12 3 2 6 6 6 12-2 2-4 3-6 3s-4-1-6-3Z"/><path d="m16 4-2 7 2 8 2-8-2-7ZM10 16l6-5 6 5"/></svg>',
  hand: '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M5 23c3-1 4-5 7-5 2 0 3 2 5 2 3 0 4-3 6-3 2 0 3 2 3 4 0 4-5 6-10 6H9c-2 0-3-1-4-4Z"/><path d="M17 12c0-2 2-4 4-4s4 2 4 4-2 4-4 4-4-2-4-4Z"/></svg>',
  room: '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M4 15 16 5l12 10v12H4V15Z"/><path d="M12 27V18h8v9"/></svg>',
  bulb: '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M10 14a6 6 0 1 1 12 0c0 4-3 5-4 8h-4c-1-3-4-4-4-8Z"/><path d="M13 25h6M14 28h4"/></svg>',
};

function fittingFrom(table) {
  for (const row of table.querySelectorAll('tr')) {
    const cells = row.querySelectorAll('th, td');
    if (cells.length < 2) continue;
    const key = cells[0].textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    const value = cells[1].textContent.replace(/\s+/g, ' ').trim();
    if (
      value &&
      /(bulb|lamp)/.test(key) &&
      (/(fitting|base|socket|type|holder)/.test(key) || /^(light )?bulbs?$/.test(key)) &&
      !/unknown|n\/a|not specified/i.test(value)
    ) {
      return value.toUpperCase();
    }
  }
  return '';
}

function point(icon, text) {
  const item = document.createElement('div');
  item.className = 'tiffany-mobile-point';
  item.innerHTML = `<span class="tiffany-mobile-point__icon">${ICONS[icon]}</span>`;
  const copy = document.createElement('span');
  copy.textContent = text;
  item.append(copy);
  return item;
}

function setBuyNowState(section, variant) {
  const link = section.querySelector('[data-tiffany-buy-now-link]');
  if (!link) return;
  const id = variant?.id ? String(variant.id) : '';
  const available = variant?.available === true;
  const source = section.parentElement?.querySelector('[data-tiffany-buy-now-source]');
  const root = window.Shopify?.routes?.root || source?.dataset.rootUrl || '/';
  if (id && available) {
    link.href = `${root}cart/${id}:1?checkout`;
    link.removeAttribute('aria-disabled');
    link.removeAttribute('tabindex');
    link.textContent = 'Buy now';
  } else {
    link.removeAttribute('href');
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('tabindex', '-1');
    link.textContent = 'Sold out';
  }
}

function initialise(section) {
  if (section.dataset.tiffanyInitialised === 'true') return;
  section.dataset.tiffanyInitialised = 'true';

  const details = section.querySelector('.product-details');
  const source = section.parentElement?.querySelector('[data-tiffany-buy-now-source]');
  const initialId = source?.dataset.variantId;
  const initialAvailable = source?.dataset.variantAvailable === 'true';
  let variantChangeVersion = 0;
  if (details && source) {
    const wrap = document.createElement('div');
    wrap.className = 'tiffany-buy-now-wrap';
    wrap.append(...source.childNodes);
    const titleGroup = details.querySelector(':scope > .group-block');
    const price = details.querySelector('product-price');
    if (price) {
      price.insertAdjacentElement('afterend', wrap);
    } else {
      titleGroup?.insertAdjacentElement('beforebegin', wrap);
    }
    setBuyNowState(section, { id: initialId, available: initialAvailable });
  }

  const title = details?.querySelector('[class*="__text_xrnftG"] h1');
  details?.querySelector('[class*="__text_xrnftG"] p')?.classList.add('tiffany-product-brand');
  if (title) title.textContent = title.textContent.replace(/^\s*belofay\s*[-–—:|]?\s*/i, '').trim();

  const description = details?.querySelector('[class*="__text_aEtTtq"]');
  const media = section.querySelector('.product-information__media');
  const table = description?.querySelector('table');
  if (description && media) {
    description.classList.add('tiffany-product-description');
    if (table) {
      const specifications = document.createElement('section');
      specifications.className = 'tiffany-product-specifications';
      specifications.setAttribute('aria-label', 'Specifications');
      specifications.innerHTML = '<h2>Specifications</h2>';
      specifications.append(table);
      media.append(specifications);

      const points = document.createElement('section');
      points.className = 'tiffany-mobile-points';
      points.setAttribute('aria-label', 'Lamp highlights');
      points.append(
        point('glass', 'Beautiful detailed stained glass'),
        point('hand', 'Individual handcrafted pieces'),
        point('room', 'Ideal for any room'),
        point('bulb', fittingFrom(table) ? `Compatible with ${fittingFrom(table)} bulb` : 'Bulb compatibility: see specifications')
      );
      media.insertBefore(points, specifications);
    }

    const mobileDescription = document.createElement('details');
    mobileDescription.className = 'tiffany-mobile-description-toggle';
    mobileDescription.innerHTML = '<summary>Full description</summary>';
    const mobileContent = document.createElement('div');
    mobileContent.append(...description.cloneNode(true).childNodes);
    mobileDescription.append(mobileContent);
    media.append(mobileDescription);

    const supportingContent = [
      media.querySelector('.tiffany-mobile-points'),
      media.querySelector('.tiffany-product-specifications'),
      mobileDescription,
    ].filter(Boolean);
    const mobileLayout = window.matchMedia('(max-width: 749px)');
    const placeSupportingContent = () => {
      const destination = mobileLayout.matches ? details : media;
      if (destination) destination.append(...supportingContent);
    };
    placeSupportingContent();
    mobileLayout.addEventListener('change', placeSupportingContent);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(section)) {
        mobileLayout.removeEventListener('change', placeSupportingContent);
      }
    }, { once: true });
  }

  section.addEventListener('shopify:product:select', (event) => {
    const promise = event.promise;
    if (!promise) return;
    const version = ++variantChangeVersion;
    promise.then(({ detail }) => {
      if (version !== variantChangeVersion) return;
      if (!detail?.resource) return setBuyNowState(section, null);
      setBuyNowState(section, detail.resource);
    });
  });
}

function initialiseAll(root = document) {
  root.querySelectorAll('.product-information').forEach(initialise);
}

document.addEventListener('DOMContentLoaded', () => initialiseAll());
document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));